// Type definition for category products
interface CategoryProduct {
  id: string;
  title: string;
  description: string;
  image: string;
  subcategory: string;
  link: string;
}

export const categories = [
  {
    id: 1,
    name: 'Culture & Creativity',
    slug: 'culture-creativity',
    icon: 'ri-palette-line',
    description: 'Explore art, music, design, and creative expression',
    featured: false,
  },
  {
    id: 2,
    name: 'Smart Betting Strategies',
    slug: 'smart-betting-strategies',
    icon: 'ri-trophy-line',
    description: 'Data-driven insights for informed betting decisions',
    featured: true,
  },
  {
    id: 3,
    name: 'Business & Wealth',
    slug: 'business-wealth',
    icon: 'ri-line-chart-line',
    description: 'Build wealth through smart business strategies',
    featured: true,
  },
  {
    id: 4,
    name: 'Culinary Living',
    slug: 'culinary-living',
    icon: 'ri-restaurant-line',
    description: 'Healthy recipes, cooking guides, and kitchen essentials',
    featured: true,
  },
  {
    id: 5,
    name: 'Digital Business & Marketing',
    slug: 'digital-business-marketing',
    icon: 'ri-megaphone-line',
    description: 'Master online business and digital marketing',
    featured: false,
  },
  {
    id: 6,
    name: 'Learning & Education',
    slug: 'learning-education',
    icon: 'ri-book-open-line',
    description: 'Resources for lifelong learning and growth',
    featured: false,
  },
  {
    id: 7,
    name: 'Careers & Work Life',
    slug: 'careers-work-life',
    icon: 'ri-briefcase-line',
    description: 'Navigate your professional journey with confidence',
    featured: false,
  },
  {
    id: 8,
    name: 'Stories & Fiction',
    slug: 'stories-fiction',
    icon: 'ri-quill-pen-line',
    description: 'Discover compelling narratives and creative writing',
    featured: false,
  },
  {
    id: 9,
    name: 'Gaming & Play',
    slug: 'gaming-play',
    icon: 'ri-gamepad-line',
    description: 'Reviews, guides, and gaming culture insights',
    featured: false,
  },
  {
    id: 10,
    name: 'Eco Living & Sustainability',
    slug: 'eco-living-sustainability',
    icon: 'ri-leaf-line',
    description: 'Live sustainably and protect our planet',
    featured: true,
  },
  {
    id: 11,
    name: 'Health, Fitness & Wellness',
    slug: 'health-fitness-wellness',
    icon: 'ri-heart-pulse-line',
    description: 'Optimize your physical and mental wellbeing',
    featured: false,
  },
  {
    id: 12,
    name: 'Home, Garden & Living',
    slug: 'home-garden-living',
    icon: 'ri-home-smile-line',
    description: 'Create beautiful, functional living spaces',
    featured: false,
  },
  {
    id: 13,
    name: 'Languages & Communication',
    slug: 'languages-communication',
    icon: 'ri-translate-2',
    description: 'Master languages and effective communication',
    featured: false,
  },
  {
    id: 14,
    name: 'Mobile Tech & Apps',
    slug: 'mobile-tech-apps',
    icon: 'ri-smartphone-line',
    description: 'Stay updated with mobile technology trends',
    featured: false,
  },
  {
    id: 15,
    name: 'Family & Parenting',
    slug: 'family-parenting',
    icon: 'ri-parent-line',
    description: 'Guidance for modern family life',
    featured: false,
  },
  {
    id: 16,
    name: 'News & Current Affairs',
    slug: 'news-current-affairs',
    icon: 'ri-newspaper-line',
    description: 'Stay informed with curated news analysis',
    featured: false,
  },
  {
    id: 17,
    name: 'Guides & Resources',
    slug: 'guides-resources',
    icon: 'ri-guide-line',
    description: 'Comprehensive how-to guides and resources',
    featured: false,
  },
  {
    id: 18,
    name: 'Personal Growth',
    slug: 'personal-growth',
    icon: 'ri-seedling-line',
    description: 'Transform yourself through continuous improvement',
    featured: false,
  },
  {
    id: 19,
    name: 'Software, Tools & Services',
    slug: 'software-tools-services',
    icon: 'ri-tools-line',
    description: 'Find the best digital tools for your needs',
    featured: false,
  },
  {
    id: 20,
    name: 'Spiritual Life',
    slug: 'spiritual-life',
    icon: 'ri-sparkling-line',
    description: 'Explore spirituality and inner peace',
    featured: false,
  },
  {
    id: 21,
    name: 'Mind, Energy & Alternative Paths',
    slug: 'mind-energy-alternative-paths',
    icon: 'ri-mind-map',
    description: 'Discover alternative approaches to wellbeing',
    featured: false,
  },
  {
    id: 22,
    name: 'Sports & Performance',
    slug: 'sports-performance',
    icon: 'ri-football-line',
    description: 'Enhance athletic performance and sports knowledge',
    featured: true,
  },
  {
    id: 23,
    name: 'Travel & Adventure',
    slug: 'travel-adventure',
    icon: 'ri-plane-line',
    description: 'Explore the world with expert travel guides',
    featured: false,
  },
];

export const smartBettingProducts = [
  {
    id: 15,
    title: 'Goal Predictor',
    category: 'Smart Betting Strategies',
    subcategory: 'Soccer',
    description: 'Advanced soccer prediction system using data analytics to forecast goal outcomes and deliver profitable accumulator tips.',
    image: 'https://public.readdy.ai/ai/img_res/7fe3b33ce0990843b7ed4a62d29050e0.jpg',
    link: '/reviews/goal-predictor-review',
    featured: false,
  },
  {
    id: 16,
    title: 'Value Multiplier',
    category: 'Smart Betting Strategies',
    subcategory: 'Horse Racing',
    description: 'Professional horse racing betting system that identifies undervalued horses and delivers consistent profits through expert value analysis.',
    image: 'https://readdy.ai/api/search-image?query=professional%20horse%20racing%20betting%20analysis%20on%20computer%20screen%20with%20racing%20form%20statistics%20odds%20comparison%20charts%20thoroughbred%20horses%20racing%20in%20background%20modern%20betting%20office%20setup%20clean%20minimalist%20background%20value%20betting%20concept&width=400&height=300&seq=valuemultiplier002&orientation=landscape',
    link: '/reviews/value-multiplier-review',
    featured: false,
  },
  {
    id: 17,
    title: 'Betting Scientist',
    category: 'Smart Betting Strategies',
    subcategory: 'Horse Racing',
    description: 'Scientific horse racing betting system using advanced algorithms and statistical analysis to identify profitable betting opportunities.',
    image: 'https://readdy.ai/api/search-image?query=scientific%20data%20analysis%20for%20horse%20racing%20betting%20with%20statistical%20charts%20graphs%20algorithms%20computer%20screens%20showing%20racing%20data%20analytics%20modern%20research%20laboratory%20setup%20clean%20minimalist%20background%20scientific%20betting%20methodology%20concept&width=400&height=300&seq=bettingscientist002&orientation=landscape',
    link: '/reviews/betting-scientist-review',
    featured: false,
  },
];

export const culinaryLivingProducts: CategoryProduct[] = [
  {
    id: 'fat-burning-kitchen',
    title: 'The Fat Burning Kitchen',
    description: 'Discover which "healthy" foods are making you fat and which foods accelerate fat-burning with this comprehensive nutrition guide',
    image: 'https://www.truthaboutabs.com/fbk-physical-2021/images/fbk-intro-img.png',
    subcategory: 'Cooking',
    link: '/reviews/fat-burning-kitchen-review',
  },
  {
    id: '500-mouthwatering-dessert-recipes',
    title: '500 Mouthwatering Dessert Recipes',
    description: 'Indulge in 500 irresistible dessert recipes from classic cakes to healthy treats, perfect for any occasion',
    image: 'https://readdy.ai/api/search-image?query=professional%203D%20cookbook%20mockup%20cover%20design%20showing%20500%20mouthwatering%20dessert%20recipes%20title%20with%20delicious%20chocolate%20cake%20strawberry%20tart%20and%20colorful%20macarons%20on%20elegant%20white%20background%20high%20quality%20product%20photography%20realistic%20cookbook%20cover&width=400&height=500&seq=dessert500book&orientation=portrait',
    subcategory: 'Recipes',
    link: '/reviews/500-mouthwatering-dessert-recipes-review',
  },
  {
    id: '250-vegan-recipes',
    title: '250 Vegan Recipes',
    description: 'Nourish your body with 250+ delicious plant-based meals for breakfast, lunch, dinner, and desserts',
    image: 'https://readdy.ai/api/search-image?query=professional%203D%20cookbook%20mockup%20cover%20design%20showing%20250%20vegan%20recipes%20title%20with%20fresh%20colorful%20vegetables%20fruits%20plant%20based%20ingredients%20on%20clean%20white%20background%20high%20quality%20product%20photography%20realistic%20vegan%20cookbook%20cover&width=400&height=500&seq=vegan250book&orientation=portrait',
    subcategory: 'Recipes',
    link: '/reviews/250-vegan-recipes-review',
  },
  {
    id: '200-delicious-smoothie-recipes',
    title: '200 Delicious Smoothie Recipes',
    description: 'Boost your health with 200 nutritious smoothie recipes for energy, weight loss, and overall wellness',
    image: 'https://200-smoothie-recipes.com/wp-content/uploads/2023/12/200_smoothie_recipes_3D1.png',
    subcategory: 'Recipes',
    link: '/reviews/200-delicious-smoothie-recipes-review',
  },
  {
    id: '500-keto-diet-recipes',
    title: '500 Keto Diet Recipes',
    description: 'Master the ketogenic lifestyle with 500 delicious low-carb, high-fat recipes for every meal',
    image: 'https://500-keto-recipes.com/wp-content/uploads/2024/09/500-Keto-Clickbank2.png',
    subcategory: 'Recipes',
    link: '/reviews/500-keto-diet-recipes-review',
  },
  {
    id: 'keto-bakery-bundle',
    title: 'Keto Bakery Bundle',
    description: 'Enjoy guilt-free baking with keto-friendly bread, dessert, and pastry recipes that taste amazing',
    image: 'https://ketobreads.net/bakery-bundle/assets/images/kb-kd-bundle.png',
    subcategory: 'Recipes',
    link: '/reviews/keto-bakery-bundle-review',
  },
  {
    id: 'complete-plant-based-cookbook',
    title: 'Complete Plant Based Cookbook',
    description: 'Transform your health with 200+ easy plant-based recipes for beginners and experienced cooks',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/9c57dcdbacd02486f9adff718ba97e03.png',
    subcategory: 'Recipes',
    link: '/reviews/complete-plant-based-cookbook-review',
  },
];

export const careersWorkLifeProducts = [
  {
    id: 'medical-courier-jobs',
    title: 'Medical Courier Jobs',
    description: 'Earn up to $5,000 per month driving your own vehicle with comprehensive medical courier training',
    image: 'https://readdy.ai/api/search-image?query=professional%20medical%20courier%20driver%20in%20blue%20uniform%20holding%20red%20medical%20delivery%20bag%20standing%20next%20to%20vehicle%20smiling%20confidently%20with%20medical%20transport%20equipment%20clean%20bright%20professional%20photography%20high%20quality%20realistic&width=800&height=600&seq=medcourier001&orientation=landscape',
    category: 'Careers & Work Life',
    subcategory: 'Training',
    link: '/reviews/medical-courier-jobs-review',
  },
];

export const ecoLivingSustainabilityProducts = [
  {
    id: 'energy-revolution-system',
    title: 'Energy Revolution System',
    description: 'Learn how to build your own renewable energy system and slash electricity bills with proven DIY methods',
    image: 'https://readdy.ai/api/search-image?query=modern%20home%20solar%20panel%20installation%20on%20residential%20rooftop%20with%20wind%20turbine%20in%20background%20renewable%20energy%20system%20clean%20sustainable%20power%20generation%20bright%20sunny%20day%20professional%20photography%20realistic%20high%20quality&width=800&height=600&seq=energyrev001&orientation=landscape',
    category: 'Eco Living & Sustainability',
    subcategory: 'Alternative Energy',
    link: '/reviews/energy-revolution-system-review',
  },
  {
    id: 'septifix',
    title: 'Septifix',
    description: 'Natural septic tank treatment tablets that eliminate odors, prevent backups, and save thousands on pumping costs',
    image: 'https://readdy.ai/api/search-image?query=eco-friendly%20septic%20system%20maintenance%20with%20natural%20treatment%20tablets%20green%20grass%20backyard%20underground%20septic%20tank%20diagram%20clean%20environment%20sustainable%20home%20care%20professional%20photography%20realistic%20high%20quality&width=800&height=600&seq=septifix001&orientation=landscape',
    category: 'Eco Living & Sustainability',
    subcategory: 'Conservation & Efficiency',
    link: '/reviews/septifix-review',
  },
];

export const healthFitnessWellnessProducts: CategoryProduct[] = [
  {
    id: 'neuro-thrive',
    title: 'Neuro-Thrive',
    description: 'Advanced brain health supplement with 7 powerful natural ingredients that support memory, focus, and cognitive function for optimal mental performance',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/97862f62c142cca778e05c30a29aab61.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/neuro-thrive-review',
  },
  {
    id: 'mitolyn',
    title: 'MITOLYN',
    description: 'Unlock your metabolic power and burn more calories with this breakthrough formula that supports healthy mitochondria levels for natural weight loss',
    image: 'https://mitolyn.com/assets/images/product-home.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/mitolyn-review',
  },
  {
    id: 'prostavive',
    title: 'ProstaVive',
    description: 'The most potent, fast-acting formula for prostate health and strong flow - support healthy blood circulation and optimize prostate function naturally',
    image: 'https://prostavive.org/home-assets/images/product.png',
    subcategory: 'Men\'s Health',
    link: '/reviews/prostavive-review',
  },
  {
    id: 'zencortex',
    title: 'ZenCortex',
    description: 'Revolutionary hearing support formula with 20+ natural ingredients that protect and enhance auditory health naturally',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/3d8f5bc728b8299f1aab980bb371b5f3.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/zencortex-review',
  },
  {
    id: 'citrusburn',
    title: 'CitrusBurn',
    description: 'The citrus secret everyone\'s talking about - burn more, crave less, and feel great all day with this Spanish fat-melting formula',
    image: 'https://citrusburn.com/images/bnrbxrgtprd.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/citrusburn-review',
  },
  {
    id: 'audifort',
    title: 'Audifort',
    description: 'Support your hearing naturally with this advanced formula designed to promote healthy auditory function and protect against age-related hearing decline',
    image: 'https://audisoothe.com/c/images/product-img.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/audifort-review',
  },
  {
    id: 'gluco6',
    title: 'Gluco6',
    description: 'Revolutionary blood sugar support formula that helps maintain healthy glucose levels and promotes metabolic wellness naturally',
    image: 'https://gluco6.com/images/product-bottle.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/gluco6-review',
  },
  {
    id: 'prodentim',
    title: 'ProDentim',
    description: 'Revolutionary probiotic supplement that supports healthy teeth and gums with 3.5 billion beneficial bacteria for optimal oral health',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/5d92d5b14737179e70f4402ebda66c89.png',
    subcategory: 'Dental Health',
    link: '/reviews/prodentim-review',
  },
  {
    id: 'provadent',
    title: 'ProvaDent',
    description: 'Advanced dental probiotic formula that supports oral microbiome balance and promotes healthy teeth and gums naturally',
    image: 'https://dentalsugarhack.com/images/provadent-product.png',
    subcategory: 'Dental Health',
    link: '/reviews/provadent-review',
  },
  {
    id: 'neuro-energizer',
    title: 'Neuro Energizer',
    description: 'Unlock your brain\'s full potential with this 7-second audio program based on Einstein\'s stolen brain research for enhanced cognitive function',
    image: 'https://cdn.prod.website-files.com/6752f4c7589e8997cdb008e3/690cbf57b4960256fe924b7a_bundle.webp',
    subcategory: 'General',
    link: '/reviews/neuro-energizer-review',
  },
  {
    id: 'the-memory-wave',
    title: 'The Memory Wave',
    description: 'Transform your memory and cognitive abilities with this 7-second brain wave audio program based on breakthrough neuroscience research',
    image: 'https://discovermemorywave.com/images/memory-wave-product.png',
    subcategory: 'General',
    link: '/reviews/the-memory-wave-review',
  },
  {
    id: 'leanbiome',
    title: 'LeanBiome',
    description: 'Revolutionary gut microbiome formula with 9 clinically-researched probiotic strains that targets the root cause of belly fat and unexplained weight gain',
    image: 'https://bestleanlife.com/affiliates/images/leanbiome-bottle.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/leanbiome-review',
  },
  {
    id: 'the-smoothie-diet',
    title: 'The Smoothie Diet',
    description: 'Rapid weight loss program featuring delicious, easy-to-make smoothies designed to help you lose weight, increase energy, and feel amazing in just 21 days',
    image: 'https://go.smoothiediet.com/images/smoothie-diet-book.png',
    subcategory: 'Diets & Weight Loss',
    link: '/reviews/the-smoothie-diet-review',
  },
  {
    id: 'sleeplean',
    title: 'SleepLean',
    description: 'Nighttime weight loss formula that helps you burn fat while you sleep by supporting healthy metabolism and deep, restorative sleep',
    image: 'https://sleeplean.net/images/sleeplean-bottle.png',
    subcategory: 'Diets & Weight Loss',
    link: '/reviews/sleeplean-review',
  },
  {
    id: 'java-burn',
    title: 'Java Burn',
    description: 'Revolutionary coffee booster that supercharges your metabolism and accelerates fat burning when mixed with your morning coffee',
    image: 'https://morningcoffeeritual.net/images/javaburn-tm.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/java-burn-review',
  },
  {
    id: 'igenics',
    title: 'iGenics',
    description: 'Plant-based vision support formula with 12 clinically-backed ingredients that promote healthier eyesight and protect against age-related vision decline',
    image: 'https://visionbreakthrough.com/img/img1.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/igenics-review',
  },
  {
    id: 'sugar-defender',
    title: 'Sugar Defender',
    description: 'Natural blood sugar support formula with 8 carefully-selected ingredients that help maintain healthy glucose levels and boost all-day energy',
    image: 'https://sugardefender24.com/assets/img/SUGARDEFENDERx6-500px.png',
    subcategory: 'Dietary Supplements',
    link: '/reviews/sugar-defender-review',
  },
];
